
import { useTranslation } from 'react-i18next';
import ReactHtmlParser from 'react-html-parser';
import axios from 'axios';
import { useCallback } from 'react';

const DatosPropiedad = ({ propiedad, lang, ruta, servicios, configweb, calendario, diasbloqueados, diasbloqueadossolos }) => {
    const { t } = useTranslation();

    var preidioma = ""
    if (lang != 'es') preidioma = lang + "/";

    let botones = document.querySelectorAll(".boton");

    const cuandoSeHaceClick = function (evento) {

        var nuevo_mes = this.getAttribute("data-nuevo-mes");
        var nuevo_ano = this.getAttribute("data-nuevo-ano");

        let token = document.getElementById('meta_token').getAttribute('content');

        const result = axios.post('/calendario0', {
            idPropiedad: propiedad.id,
            nuevo_mes: nuevo_mes,
            nuevo_ano: nuevo_ano,
            bloqueos: JSON.stringify(diasbloqueados),
            bloqueossolos: JSON.stringify(diasbloqueadossolos),
            lang: lang
        }, {
            headers: {
                'content-type': 'text/json',
                'X-CSRF-TOKEN': token
            }
        })
            .then((response) => {
                document.querySelectorAll(".calendario")[0].innerHTML = response.data;
                botones = document.querySelectorAll(".boton");
                botones.forEach(boton => {
                    boton.addEventListener("click", cuandoSeHaceClick);
                })
            })

    }

    botones.forEach(boton => {
        boton.addEventListener("click", cuandoSeHaceClick);
    })


    const handleDescargaDocumento = useCallback(async () => {
        try {
            // Parsear el JSON
            const eldocumento = JSON.parse(propiedad.eldocumento);

            if (eldocumento?.url) {
                // Si hay URL directa, abrimos en nueva pestaña
                window.open(eldocumento.url, '_blank');
            } else if (eldocumento?.file) {
                // Si es archivo, llamamos a la API
                await descargarArchivoAPI(eldocumento.file);
            } else {
                console.warn("No hay URL ni archivo disponible");
            }
        } catch (error) {
            console.error("Error al procesar el documento:", error);
        }
    }, [propiedad]); // Dependencias: propiedad, lang, etc.

    const descargarArchivoAPI = async (nombreArchivo) => {
        // Obtener token (asegúrate de que el meta tag existe)
        const tokenElement = document.getElementById('meta_token');
        const token = tokenElement ? tokenElement.getAttribute('content') : '';

        try {
            const response = await axios.post(
                '/descargaDocumentoPropiedad',
                {
                    idpropiedad: propiedad.id,
                    idioma: lang,
                    //nombrearchivo: nombreArchivo
                },
                {
                    headers: {
                        'X-CSRF-TOKEN': token
                    },
                    responseType: 'blob', // IMPORTANTE: Para descargar archivos
                    validateStatus: (status) => status >= 200 && status < 300 // Acepta cualquier código 2xx
                }
            );

            console.log("Tipo de respuesta:", response.data.type);
            console.log("Tamaño de respuesta:", response.data.size);

            if (!response.data || response.data.size === 0) {
                throw new Error("El servidor devolvió un archivo vacío");
            }

            // Crear un enlace temporal para forzar la descarga del Blob
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;

            const disposition = response.headers['content-disposition'];
            let fileName = nombreArchivo;
            if (disposition) {
                const filenameMatch = disposition.match(/filename="(.+)"/);
                if (filenameMatch) fileName = filenameMatch[1];
            }

            link.setAttribute('download', fileName); // Nombre del archivo
            document.body.appendChild(link);
            link.click();

            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            console.log("Descarga completada");

        } catch (error) {
            console.error("Error en la descarga:", error);
            // Si el error es de Axios, revisa el response.data del error
            if (error.response) {
                console.error("Respuesta del servidor:", error.response.data);
            }
            throw error;
        }
    };

    let eldocumento = null;
    try {
        eldocumento = JSON.parse(propiedad.eldocumento);
    } catch (e) {
        eldocumento = null;
    }

    const esEnlaceDirecto = eldocumento?.url;
    const esArchivoAPI = eldocumento?.file;


    return (
        <>
            <section className="u-clearfix u-section-1" id="block-16">
                <div className="u-clearfix u-sheet u-valign-middle-lg u-valign-middle-md u-valign-middle-sm u-valign-middle-xl u-sheet-1">
                    <h1 className="u-align-right u-custom-font u-font-oswald u-text u-text-black u-title u-text-1" data-animation-name="customAnimationIn" data-animation-duration="1000" data-animation-delay="0" data-animation-out="0">{propiedad.nombre}</h1>
                    <p className="u-align-left u-custom-font u-font-montserrat u-text u-text-2"> {propiedad.ciudad}, {propiedad.pais}</p>
                    <p className="u-align-center u-custom-font u-font-montserrat u-text u-text-3">
                        <a href="#" className="u-active-none u-border-none u-btn u-button-link u-button-style u-hover-none u-none u-text-palette-1-base u-btn-1" target="_blank">
                            <span className="u-icon">
                                <svg className="u-svg-content" viewBox="0 0 54.757 54.757" x="0px" y="0px" style={{ width: "1em", height: "1em" }}>
                                    <path d="M40.94,5.617C37.318,1.995,32.502,0,27.38,0c-5.123,0-9.938,1.995-13.56,5.617c-6.703,6.702-7.536,19.312-1.804,26.952
            L27.38,54.757L42.721,32.6C48.476,24.929,47.643,12.319,40.94,5.617z M27.557,26c-3.859,0-7-3.141-7-7s3.141-7,7-7s7,3.141,7,7
            S31.416,26,27.557,26z">
                                    </path>
                                </svg>
                            </span>&nbsp;{t("Mostrar mapa")}
                        </a>
                    </p>
                </div>
            </section>
            <section className="u-align-center u-clearfix u-container-align-center u-section-2" id="block-15">
                <div className="u-clearfix u-sheet u-valign-middle-lg u-valign-middle-sm u-sheet-1">
                    <h2 className="u-align-center u-text u-text-1">Sample Headline</h2>
                    <div className="u-carousel u-expanded-width u-gallery u-layout-thumbnails u-lightbox u-no-transition u-show-text-on-hover u-gallery-1" id="carousel-f23d" data-interval="5000" data-u-ride="carousel">
                        <div className="u-carousel-inner u-gallery-inner u-gallery-inner-1" role="listbox">
                            {
                                propiedad.fotos_web.map((unafoto, index) => (
                                    <div className={index == 0 ? "u-active u-carousel-item u-gallery-item u-carousel-item-" + (index + 1) : "u-carousel-item u-gallery-item u-carousel-item-" + (index + 1)} data-image-width="3200" data-image-height="2400" key={"foto" + index}>
                                        <div className="u-back-slide">
                                            <img className="u-back-image u-expanded" src={ruta + "/propiedades/" + propiedad.id + "/fotos/web/" + unafoto.nombre} />
                                        </div>
                                        <div className={"u-align-center u-over-slide u-valign-bottom u-over-slide-" + (index + 1)}>
                                            <h3 className="u-gallery-heading">{unafoto.titulo}</h3>
                                            <p className="u-gallery-text">{unafoto.alt}</p>
                                        </div>
                                        {index % 2 == 0 ?
                                            <>
                                                <style data-mode="XL" data-visited="true"></style>
                                                <style data-mode="LG"></style>
                                                <style data-mode="MD" data-visited="true"></style>
                                                <style data-mode="SM"></style>
                                                <style data-mode="XS" data-visited="true"></style>
                                            </>
                                            :
                                            ""
                                        }
                                    </div>
                                ))
                            }
                        </div>
                        <a className="u-absolute-vcenter u-carousel-control u-carousel-control-prev u-grey-70 u-icon-circle u-opacity u-opacity-70 u-spacing-10 u-text-white u-carousel-control-1" href="#carousel-f23d" role="button" data-u-slide="prev">
                            <span aria-hidden="true">
                                <svg viewBox="0 0 451.847 451.847">
                                    <path d="M97.141,225.92c0-8.095,3.091-16.192,9.259-22.366L300.689,9.27c12.359-12.359,32.397-12.359,44.751,0
    c12.354,12.354,12.354,32.388,0,44.748L173.525,225.92l171.903,171.909c12.354,12.354,12.354,32.391,0,44.744
    c-12.354,12.365-32.386,12.365-44.745,0l-194.29-194.281C100.226,242.115,97.141,234.018,97.141,225.92z"></path>
                                </svg>
                            </span>
                            <span className="sr-only">
                                <svg viewBox="0 0 451.847 451.847">
                                    <path d="M97.141,225.92c0-8.095,3.091-16.192,9.259-22.366L300.689,9.27c12.359-12.359,32.397-12.359,44.751,0
c12.354,12.354,12.354,32.388,0,44.748L173.525,225.92l171.903,171.909c12.354,12.354,12.354,32.391,0,44.744
c-12.354,12.365-32.386,12.365-44.745,0l-194.29-194.281C100.226,242.115,97.141,234.018,97.141,225.92z"></path>
                                </svg>
                            </span>
                        </a>
                        <a className="u-absolute-vcenter u-carousel-control u-carousel-control-next u-grey-70 u-icon-circle u-opacity u-opacity-70 u-spacing-10 u-text-white u-carousel-control-2" href="#carousel-f23d" role="button" data-u-slide="next">
                            <span aria-hidden="true">
                                <svg viewBox="0 0 451.846 451.847">
                                    <path d="M345.441,248.292L151.154,442.573c-12.359,12.365-32.397,12.365-44.75,0c-12.354-12.354-12.354-32.391,0-44.744
L278.318,225.92L106.409,54.017c-12.354-12.359-12.354-32.394,0-44.748c12.354-12.359,32.391-12.359,44.75,0l194.287,194.284
c6.177,6.18,9.262,14.271,9.262,22.366C354.708,234.018,351.617,242.115,345.441,248.292z"></path>
                                </svg>
                            </span>
                            <span className="sr-only">
                                <svg viewBox="0 0 451.846 451.847">
                                    <path d="M345.441,248.292L151.154,442.573c-12.359,12.365-32.397,12.365-44.75,0c-12.354-12.354-12.354-32.391,0-44.744
L278.318,225.92L106.409,54.017c-12.354-12.359-12.354-32.394,0-44.748c12.354-12.359,32.391-12.359,44.75,0l194.287,194.284
c6.177,6.18,9.262,14.271,9.262,22.366C354.708,234.018,351.617,242.115,345.441,248.292z"></path>
                                </svg>
                            </span>
                        </a>
                        <ol className="u-carousel-thumbnails">
                            {
                                propiedad.fotos_web.map((unafoto, index) => (
                                    <li className={index == 0 ? "u-active u-carousel-thumbnail u-carousel-thumbnail-" + (index + 1) : "u-carousel-thumbnail u-carousel-thumbnail-" + (index + 1)} data_u_target="#carousel-f23d" data-u-slide-to={index} key={"thumb-" + index}>
                                        <img className="u-carousel-thumbnail-image u-image" src={ruta + "/propiedades/" + propiedad.id + "/fotos/web/thumb/" + unafoto.nombre} />
                                    </li>
                                ))
                            }
                        </ol>
                    </div>
                </div>
            </section>
            <section className="u-clearfix u-section-3" id="block-17">
                <div className="u-clearfix u-sheet u-valign-middle-lg u-valign-middle-md u-valign-middle-sm u-valign-middle-xs u-sheet-1">
                    <div className="mt-2 row icones-propietat">
                        <div className="col-md-2 col-6 centradoalineado mb-15">
                            <center>
                                <div className="iconoprop">
                                    <i className="fa-duotone fa-ruler-triangle font30"></i>
                                </div>
                            </center>
                            <br />
                            <span className="dobletam">
                                {propiedad.metros_cuadrados} M
                            </span>
                        </div>

                        <div className="col-md-2 col-6 centradoalineado mb-15">
                            <center>
                                <div className="iconoprop">
                                    <i className="fa-duotone fa-bed font30"></i>
                                </div>
                            </center>
                            <br />

                            <span className="dobletam">
                                {propiedad.num_habitaciones} {t("Cabinas")}
                            </span>
                        </div>

                        <div className="col-md-2 col-6 centradoalineado mb-15">
                            <center>
                                <div className="iconoprop">
                                    <i className="fa-duotone fa-users font30"></i>
                                </div>
                            </center>

                            <br />

                            <span className="dobletam">
                                {propiedad.capacidad_maxima} {t("Adultos")}
                            </span>
                        </div>
                    </div>
                </div>
            </section>
            <section className="u-align-center u-clearfix u-container-align-center u-section-4" id="block-12">
                <div className="u-clearfix u-sheet u-valign-middle-lg u-valign-middle-md u-valign-middle-sm u-valign-middle-xs u-sheet-1">
                    <div className="data-layout-selected u-clearfix u-expanded-width u-layout-wrap u-layout-wrap-1">
                        <div className="u-layout">
                            <div className="u-layout-row">
                                <div className="u-container-style u-layout-cell u-size-60 u-layout-cell-1">
                                    <div className="u-container-layout u-container-layout-1">
                                        <h1 className="u-align-center u-custom-font u-text u-text-font u-text-1" data-animation-name="customAnimationIn" data-animation-duration="1000" data-animation-delay="0" data-animation-out="0">{t("Descripción")}</h1>

                                        {ReactHtmlParser(propiedad.ladesc)}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <style data-mode="XXL">
                    {`
                        @media (max-width: 0px) {
                            .u-section-4 .u-sheet-1 {
                                min-height: 613px;
                            }
                            .u-section-4 .u-text-1 {
                                width: 758px;
                                min-height: 478px;
                                height: auto;
                                margin-top: 60px;
                                margin-bottom: 60px;
                                margin-left: auto;
                                margin-right: auto;
                            }
                            .u-block-3e91-10 {
                                position: absolute;
                                bottom: 10px;
                                width: auto;
                                height: auto;
                            }
                            .u-block-3e91-25 {
                                background-image: linear-gradient(0deg, rgba(0,0,0,0.4), rgba(0,0,0,0.4)), url("images/90fc53c9.svg");
                                background-position: 50% 50%;
                            }
                            .u-block-3e91-26 {
                                padding-top: 30px;
                                padding-bottom: 30px;
                                padding-left: 60px;
                                padding-right: 60px;
                            }
                            .u-block-3e91-32 {
                                margin-top: 0;
                                margin-bottom: 0;
                                margin-left: auto;
                                margin-right: auto;
                            }
                            .u-block-3e91-33 {
                                width: 409px;
                                margin-top: 20px;
                                margin-left: auto;
                                margin-right: auto;
                                margin-bottom: 0;
                            }
                            .u-block-3e91-34 {
                                border-style: none;
                                font-weight: 700;
                                text-transform: uppercase;
                                font-size: 0.875rem;
                                letter-spacing: 1px;
                                background-image: none;
                                margin-top: 30px;
                                margin-left: auto;
                                margin-right: auto;
                                margin-bottom: 0;
                            }
                            .u-block-3e91-35 {
                                background-image: linear-gradient(0deg, rgba(0,0,0,0.4), rgba(0,0,0,0.4)), url("images/90fc53c9.svg");
                                background-position: 50% 50%;
                            }
                            .u-block-3e91-36 {
                                padding-top: 30px;
                                padding-bottom: 30px;
                                padding-left: 60px;
                                padding-right: 60px;
                            }
                            .u-block-3e91-37 {
                                margin-top: 0;
                                margin-bottom: 0;
                                margin-left: auto;
                                margin-right: auto;
                            }
                            .u-block-3e91-38 {
                                width: 409px;
                                margin-top: 20px;
                                margin-left: auto;
                                margin-right: auto;
                                margin-bottom: 0;
                            }
                            .u-block-3e91-39 {
                                border-style: none;
                                font-weight: 700;
                                text-transform: uppercase;
                                font-size: 0.875rem;
                                letter-spacing: 1px;
                                background-image: none;
                                margin-top: 30px;
                                margin-left: auto;
                                margin-right: auto;
                                margin-bottom: 0;
                            }
                            .u-block-3e91-16 {
                                width: 38px;
                                height: 38px;
                                background-image: none;
                                left: -58px;
                                position: absolute;
                                right: auto;
                            }
                            .u-section-4 .u-container-layout-1 {
                                width: 38px;
                                height: 38px;
                                background-image: none;
                                left: auto;
                                position: absolute;
                                right: -58px;
                            }
                        }
                    `}
                </style>
            </section>

            <section className="u-align-center u-clearfix u-container-align-center u-gradient u-section-5" id="sec-311c">
                <div className="u-clearfix u-sheet u-valign-middle-lg u-valign-middle-sm u-valign-middle-xl u-sheet-1">
                    <div className="data-layout-selected u-clearfix u-expanded-width u-layout-wrap u-layout-wrap-1">
                        <div className="u-layout">
                            <div className="u-layout-row">
                                {ReactHtmlParser(propiedad.lainfo)}
                            </div>
                        </div>
                    </div>
                </div>
                <style data-mode="XXL">
                    {`
                        @media (max-width: 0px) {
                            .u-section-5 .u-sheet-1 {
                                min-height: 613px;
                            }
                            .u-section-5 .u-layout-wrap-1 {
                                width: 758px;
                                min-height: 478px;
                                height: auto;
                                margin-top: 60px;
                                margin-bottom: 60px;
                                margin-left: auto;
                                margin-right: auto;
                            }
                            .u-section-5 .u-layout-cell-1 {
                                position: absolute;
                                bottom: 10px;
                                width: auto;
                                height: auto;
                            }
                            .u-block-c42e-25 {
                                background-image: linear-gradient(0deg, rgba(0,0,0,0.4), rgba(0,0,0,0.4)), url("images/90fc53c9.svg");
                                background-position: 50% 50%;
                            }
                            .u-block-c42e-26 {
                                padding-top: 30px;
                                padding-bottom: 30px;
                                padding-left: 60px;
                                padding-right: 60px;
                            }
                            .u-block-c42e-32 {
                                margin-top: 0;
                                margin-bottom: 0;
                                margin-left: auto;
                                margin-right: auto;
                            }
                            .u-block-c42e-33 {
                                width: 409px;
                                margin-top: 20px;
                                margin-left: auto;
                                margin-right: auto;
                                margin-bottom: 0;
                            }
                            .u-block-c42e-34 {
                                border-style: none;
                                font-weight: 700;
                                text-transform: uppercase;
                                font-size: 0.875rem;
                                letter-spacing: 1px;
                                background-image: none;
                                margin-top: 30px;
                                margin-left: auto;
                                margin-right: auto;
                                margin-bottom: 0;
                            }
                            .u-block-c42e-35 {
                                background-image: linear-gradient(0deg, rgba(0,0,0,0.4), rgba(0,0,0,0.4)), url("images/90fc53c9.svg");
                             background-position: 50% 50%;
                            }
                            .u-block-c42e-36 {
                                padding-top: 30px;
                                padding-bottom: 30px;
                                padding-left: 60px;
                                padding-right: 60px;
                            }
                            .u-block-c42e-37 {
                                margin-top: 0;
                                margin-bottom: 0;
                                margin-left: auto;
                                margin-right: auto;
                            }
                            .u-block-c42e-38 {
                                width: 409px;
                                margin-top: 20px;
                                margin-left: auto;
                                margin-right: auto;
                                margin-bottom: 0;
                            }
                            .u-block-c42e-39 {
                                border-style: none;
                                font-weight: 700;
                                text-transform: uppercase;
                                font-size: 0.875rem;
                                letter-spacing: 1px;
                                background-image: none;
                                margin-top: 30px;
                                margin-left: auto;
                                margin-right: auto;
                                margin-bottom: 0;
                            }
                            .u-section-5 .u-text-2 {
                                width: 38px;
                                height: 38px;
                                background-image: none;
                                left: -58px;
                                position: absolute;
                                right: auto;
                            }
                            .u-block-c42e-7 {
                                width: 38px;
                                height: 38px;
                                background-image: none;
                                left: auto;
                                position: absolute;
                                right: -58px;
                            }
                        }
                    `}
                </style>
            </section>

            <section className="u-clearfix u-section-6" id="block-19">
                <div className="u-clearfix u-sheet u-valign-top-lg u-valign-top-md u-valign-top-sm u-valign-top-xs u-sheet-1">
                    <h1 className="u-align-center u-custom-font u-text u-text-default u-text-font u-text-1" data-animation-name="customAnimationIn" data-animation-duration="1000" data-animation-delay="0" data-animation-out="0">{t("Comodidades")}</h1>
                    <div className="mt-5 row">
                        {
                            servicios.map((unservicio, index) => {
                                return (
                                    <div className="col-md-4 col-sm-4 col-6" title={unservicio.elnombre} data-original-title={unservicio.elnombre} key={"s" + index} style={{ height: "50px" }}>
                                        <i className={"fa " + unservicio.imagen + " fa-2xl"} style={{ color: "" + configweb.color_corporativo_web + "" }}></i> <span className="with-icon">{unservicio.elnombre}</span>
                                    </div>
                                );
                            })
                        }
                    </div>
                </div>
            </section >

            <section className="u-clearfix u-section-7" id="sec-4182">
                <div className="u-clearfix u-sheet u-valign-top-lg u-valign-top-md u-valign-top-sm u-valign-top-xs u-sheet-1">
                    <h1 className="u-align-center u-custom-font u-text u-text-default u-text-font u-text-1" data-animation-name="customAnimationIn" data-animation-duration="1000" data-animation-delay="0" data-animation-out="0">{t("Disponibilidad")}</h1>

                    <div className="mt-5 calendario" align="center">
                        {ReactHtmlParser(calendario)}
                    </div>

                    <ul className="clearfix map-neighbour-label" style={{ listStyle: "none" }}>
                        <li className="color-04">
                            {t("Ocupado")}
                        </li>
                        <li className="color-05">
                            {t("Se puede salir")}
                        </li>
                        <li className="color-06">
                            {t("Se puede entrar")}
                        </li>
                    </ul>

                    <a
                        href={esEnlaceDirecto ? eldocumento.url : "#"}
                        className="u-align-center u-border-none u-btn u-btn-round u-button-style u-custom-color-5 u-file-link u-hover-custom-color-10 u-hover-feature u-radius u-btn-1"
                        title="Documento"
                        target={esEnlaceDirecto ? "_blank" : undefined} // Solo abrir nueva pestaña si es URL
                        onClick={(e) => {
                            if (esArchivoAPI) {
                                e.preventDefault(); // Evitar que el href "#" recargue la página
                                handleDescargaDocumento();
                            }
                        }}
                    >
                        {t("DESCARGA PDF")}
                    </a>
                    <a href={"/" + preidioma + t("contacto")} className="u-align-center u-border-none u-btn u-btn-round u-button-style u-custom-color-5 u-hover-custom-color-10 u-hover-feature u-radius u-btn-2" title="Solicitar propuesta personalizada" target="_blank"> {t("Solicitar PRESUPUESTO")}</a>
                </div>
            </section>
        </>
    )
}
export default DatosPropiedad;
